import { STATUSDRAFT } from "../../components/Dashboard/DataEntry/constants/common";
import {
  UPDATE_SURVEYS_BUILDER_LIST,
  TOGGLE_SURVEYS_BUILDER_LIST_LOADING,
  SURVEYS_BUILDER_LIST_ERROR,
  UPDATE_SURVEYS_BUILDER_USERS_LIST,
  UPDATE_SURVEYS_BUILDER_CLASSES_LIST,
  UPDATE_SURVEYS_BUILDER_FILTERED_USERS,
  UPDATE_SURVEYS_BUILDER_FILTERED_CLASSES,
  UPDATE_SURVEYS_BUILDER_TEMPLATE,
  SURVEY_USERS_CHECKED_IDS,
  UPDATE_SURVEY,
  RESET_SURVEY_BUILDER_STATE,
  SURVEY_BUILDER_UPDATE_TOTAL_LIST,
} from "../actions/dataEntrySurveyBuilderActions";

const initState = {
  name: "Data Entry Survey Builder",
  surveysBuilder: {
    dueDate: null,
    name: "",
    notes: "",
    round: "",
    error: {},
    status: STATUSDRAFT, //Default value
    loading: false,
    list: [],
    totalList: 0,
    totalFilterList: [],
    filteredUsers: [],
    filteredClasses: [],
    usersList: [],
    classesList: [],
    template: null,
    checkedIds: [],
    updateUsers: [],
  },
};

const dataEntrySurveyBuilderReducer = (state = initState, action) => {
  let newState = { ...state };

  switch (action.type) {
    case UPDATE_SURVEYS_BUILDER_USERS_LIST:
      newState.surveysBuilder.usersList = action.payload.value;
      break;
    case UPDATE_SURVEYS_BUILDER_CLASSES_LIST:
      newState.surveysBuilder.classesList = action.payload.value;
      break;
    case UPDATE_SURVEYS_BUILDER_LIST:
      newState.surveysBuilder.list = action.payload.value;
      break;
    case TOGGLE_SURVEYS_BUILDER_LIST_LOADING:
      newState.surveysBuilder.loading = action.payload.value;
      break;
    case SURVEYS_BUILDER_LIST_ERROR:
      newState.surveysBuilder.error = action.payload.value;
      break;

    case UPDATE_SURVEYS_BUILDER_FILTERED_USERS:
      newState.surveysBuilder.filteredStudents = action.payload.value;
      break;
    case UPDATE_SURVEYS_BUILDER_FILTERED_CLASSES:
      newState.surveysBuilder.filteredClasses = action.payload.value;
      break;
    case UPDATE_SURVEYS_BUILDER_TEMPLATE:
      newState.surveysBuilder.template = action.payload.value;
      newState.surveysBuilder.error = {
        ...newState.surveysBuilder.error,
        template: null,
      };
      break;

    case SURVEY_USERS_CHECKED_IDS:
      newState.surveysBuilder.checkedIds = action.ids;
      break;

    case UPDATE_SURVEY:
      newState.surveysBuilder = {
        ...state.surveysBuilder,
        ...action.payload,
      };
      break;

    case SURVEY_BUILDER_UPDATE_TOTAL_LIST:
      newState.surveysBuilder[action.name] = action.total || 0;
      break;

    case RESET_SURVEY_BUILDER_STATE:
      newState.surveysBuilder = { ...initState?.surveysBuilder };
      break;

    default:
      break;
  }
  return newState;
};

export default dataEntrySurveyBuilderReducer;
